// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1317":"904eae1c","1733":"728b07dd","3675":"728b07dd","8777":"fe58350d","9729":"728b07dd"}[chunkId] + ".chunk.css";
};